<template>
  <v-sheet tile class="fill-height">
    <v-container>

      <div class="google-map mb-6">
        <GmapMap :options="{
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoomControl: false,
                    fullscreenControl:false,
                    gestureHandling : 'cooperative',}"
                 @idle="sync"
                 @center_changed="updateCenter"
                 :center="map_center" :zoom="zoom"
                 map-type-id="terrain">
          <GmapMarker :clickable="false" :draggable="false" :position="center"/>
        </GmapMap>
      </div>
      <FullscreenModalWithSlot :dense="false" @opened="toggleOverlay" @closed="toggleOverlay">
        <template v-slot:activator>
          <v-btn depressed color="primary" class="toggle-modal ">
            <v-icon>fullscreen</v-icon>
          </v-btn>
        </template>
        <template v-slot:toolbar_left>
          <v-btn icon color="white">
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>
        </template>
        <template v-slot:content>
          <div class="map">
            <GmapMap :options="{
                    streetViewControl: false,
                    mapTypeControl: true,
                    zoomControl: true,
                    gestureHandling : 'cooperative',}"
                     @idle="sync"
                     @center_changed="updateCenter"
                     :center="map_center" :zoom="zoom"
                     map-type-id="terrain">
              <GmapMarker :clickable="false" :draggable="false" :position="center"/>
            </GmapMap>
          </div>

        </template>
      </FullscreenModalWithSlot>

      <v-spacer style="height: 50vh"></v-spacer>
      <v-form v-model="valid">
        <v-text-field background-color="field_background" filled light required
                      :rules="[v => !!v || 'Address is required']" placeholder=" "
                      v-model="address" label="Store address" name="address"
                      ref="text_input" @select="reInt()" required></v-text-field>
        <v-text-field background-color="field_background" filled light required
                      :rules="[v => !!v || 'Store ID is required']"
                      type="text"
                      v-model="store_name" label="Store ID" name="store_name"/>
        <v-text-field background-color="field_background" filled light required
                      :rules="[v => !!v || 'Phone number is required']"
                      type="tel"
                      v-mask="'+1 (###) ###-####'"
                      v-model="phone" label="Store Phone Number" name="phone_number"/>
        <FullscreenModalWithSlot :dense="true" @opened="toggleOverlay" @closed="toggleOverlay">
          <template v-slot:activator>
            <v-text-field loading loader-height="0" background-color="field_background" filled
                          readonly :rules="[v => !!v || 'Please select a Timezone']"
                          v-model="working_hours"
            >
              <template v-slot:prepend-inner>
                <v-icon color="primary" class="mr-2">schedule</v-icon>
              </template>
              <template v-slot:append>
                <v-icon color="primary">keyboard_arrow_right</v-icon>
              </template>
            </v-text-field>
          </template>
          <template v-slot:content>
            <div class="time-containers">
              <div class="pa-4">
                <div class="black--text title">
                  Hours of Operations
                </div>
                <div class="font-weight-thin font-italic subtitle-2">Select days to modify hours</div>
              </div>

              <v-expansion-panels tile accordion>
                <v-expansion-panel v-for="day in weekdays">
                  <v-expansion-panel-header class="working-hours">
                    <span class="text-left">
                      {{day.name}}
                    </span>
                    <span>{{convert_to_time('open_time',day)}} - {{convert_to_time('close_time',day)}}</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-select dense background-color="field_background" filled label="Opens"
                              v-model="$data['open_time'+ '_'+day.abbr]"
                              :items="time_values"></v-select>
                    <v-select dense background-color="field_background" filled label="Closes"
                              v-model="$data['close_time'+ '_'+day.abbr]"
                              :items="time_values"></v-select>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>

            </div>
          </template>
          <template v-slot:closing-btn-title>Save</template>
        </FullscreenModalWithSlot>
        <FullscreenModalWithSlot :dense="true" :selectable="true" @opened="toggleOverlay" @closed="toggleOverlay">
          <template v-slot:activator>
            <v-text-field loading loader-height="0" background-color="field_background" filled
                          readonly :rules="[v => !!v || 'Please select a Timezone']"
                          label="Timezone" v-model="display_timezone">
              <template v-slot:prepend-inner>
                <v-icon color="primary" class="mr-2">language</v-icon>
              </template>
              <template v-slot:append>
                <v-icon color="primary">keyboard_arrow_right</v-icon>
              </template>
            </v-text-field>
          </template>
          <template v-slot:content>
            <v-list class="my-2">
              <v-list-item class="px-2" @click="setTimezone(zone)" v-for="zone in timezoneValues">
                <v-list-item-icon class="mr-2">
                  <v-icon color="primary">place</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{zone.text}}</v-list-item-title>
                  <v-list-item-subtitle>{{zone.subtext}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </FullscreenModalWithSlot>
        <div class="general_details">
          <div class="title">
            <div class="black--text clarification">
              <div>
                Store Preferences
              </div>
              <FullscreenModalWithSlot :dense="true" @opened="toggleOverlay" @closed="toggleOverlay">
                <template v-slot:activator>
                  <v-icon color="primary" style="opacity: .6;cursor: pointer">help</v-icon>
                </template>
                <template v-slot:content>
                  <div class="pa-5">
                    <div class="single-clarification mb-5" v-for="clarification in clarifications_list">
                      <div class="clarification-title font-weight-bold">
                        {{clarification.title}}
                      </div>
                      <div class="clarification-text ">
                        {{clarification.text}}
                      </div>
                    </div>
                  </div>
                </template>
              </FullscreenModalWithSlot>
            </div>
          </div>
        </div>
        <div class="slider-element">
          <v-slider
            label="Max Visitors"
            v-model="slider"
            :thumb-size="24"
            :thumb-label="true"
            track-color="#BCDBFF"
            max="600"
            min="1"
          ></v-slider>
          <v-text-field :rules="sliderRules" type="number" v-model.number="slider" label="Visitors" filled
                        background-color="field_background">

          </v-text-field>
        </div>
        <div class="slider-element">
          <v-slider
            label="Visit Duration"
            track-color="#BCDBFF"
            v-model="duration"
            :thumb-size="24"
            :thumb-label="true"
            min="1"
            max="600"
          ></v-slider>
          <v-text-field :rules="sliderRules" type="number" v-model.number="duration" label="Minutes" filled
                        background-color="field_background">

          </v-text-field>
        </div>
        <div class="slider-element">
          <v-slider
            track-color="#BCDBFF"
            label="Automated Exit"
            v-model="minutes_before_out"
            :thumb-size="24"
            min="1"
            :thumb-label="true"
            max="600"
          ></v-slider>
          <v-text-field :rules="sliderRules" type="number" v-model.number="minutes_before_out" label="Minutes" filled
                        background-color="field_background">

          </v-text-field>
        </div>
        <div class="slider-element">
          <v-slider
            track-color="#BCDBFF"
            label="Code Expiration"
            v-model="minutes_before_expire"
            :thumb-size="24"
            min="1"
            :thumb-label="true"
            max="600"
          ></v-slider>
          <v-text-field :rules="sliderRules" type="number" v-model.number="minutes_before_expire" label="Minutes" filled
                        background-color="field_background">

          </v-text-field>
        </div>


        <v-btn :loading="loadingState" tile text color="white" @click="saveStore" class="fixed-btn"
               :disabled="!valid || address == 'Fetching Address...'">Save
        </v-btn>
      </v-form>
      <v-overlay v-model="overlay"></v-overlay>
    </v-container>
  </v-sheet>
</template>


<script>
  import {process_api_error} from "@/utils/utils"
  import {PAGE_IDS} from "../utils/constants"
  import * as VueGoogleMaps from "vue2-google-maps";
  import {gmapApi} from 'vue2-google-maps'
  import {mapGetters} from "vuex";
  import {doUpdateStore} from "../graphql/mutations";
  import FullscreenModalWithSlot from "../Elements/FullscreenModalWithSlot";
  import Vue from "vue";
  import {getStore} from "../graphql/queries";

  export default {
    name: "StoreEdit",
    components: {FullscreenModalWithSlot},
    data: function () {
      return {
        display_timezone: '',
        sliderRules: [
          v => (v && v > 0) || "Value must be above 0",
        ],
        overlay: false,
        is_fullscreen: false,
        clarifications_list: [
          {
            title: 'Max Visitors',
            text: 'Set the maximum amount of visitors allowed into the store at one time.'
          },
          {
            title: 'Visit Duration',
            text: 'Set the maximum duration of the visit per visitor.'
          },
          {
            title: 'Automated Exit',
            text: 'The automated exit capability is a failsafe elapsed time feature to maintain an efficient queue. It is deployed when a visitor has forgotten to scan their QR code when leaving after their visit. Set this time based off of the average visit time per visitor.'
          },
          {
            title: 'Code Expiration',
            text: 'Set the amount of time the visitor has to scan their QR code upon entrance before they are automatically timed out and their reservation is cancelled.'
          }
        ],
        selected: true,
        weekdays: [
          {
            name: 'Monday',
            abbr: 'mon'
          },
          {
            name: 'Tuesday',
            abbr: 'tue'
          },
          {
            name: 'Wednesday',
            abbr: 'wed'
          },
          {
            name: 'Thursday',
            abbr: 'thu'
          },
          {
            name: 'Friday',
            abbr: 'fri'
          },
          {
            name: 'Saturday',
            abbr: 'sat'
          },

          {
            name: 'Sunday',
            abbr: 'sun'
          },
        ],
        working_hours: 'Hours of Operation',
        store_name: '',
        valid: false,
        open_time_mon: 9 * 60,
        close_time_mon: 22 * 60,
        open_time_tue: 9 * 60,
        close_time_tue: 22 * 60,
        open_time_wed: 9 * 60,
        close_time_wed: 22 * 60,
        open_time_thu: 9 * 60,
        close_time_thu: 22 * 60,
        open_time_fri: 9 * 60,
        close_time_fri: 22 * 60,
        open_time_sat: 9 * 60,
        close_time_sat: 22 * 60,
        open_time_sun: 9 * 60,
        close_time_sun: 22 * 60,
        slider: 10,
        duration: 10,
        lat: 37,
        lng: -101,
        address: '',
        phone: '',
        timezone: '',
        minutes_before_expire: 24 * 60,
        minutes_before_out: 3 * 60,
        autocomplete: null,
        geocoder: null,
        center: {
          lat: 37,
          lng: -101
        },
        map_center: {
          lat: 37,
          lng: -101
        },
        zoom: 5,
        timer_id: undefined
      }
    },
    mounted: function () {
      this.store_name = this.store.name
      this.open_time_mon = this.store.open_time_mon
      this.close_time_mon = this.store.close_time_mon
      this.open_time_tue = this.store.open_time_tue
      this.close_time_tue = this.store.close_time_tue
      this.open_time_wed = this.store.open_time_wed
      this.close_time_wed = this.store.close_time_wed
      this.open_time_thu = this.store.open_time_thu
      this.close_time_thu = this.store.close_time_thu
      this.open_time_fri = this.store.open_time_fri
      this.close_time_fri = this.store.close_time_fri
      this.open_time_sat = this.store.open_time_sat
      this.close_time_sat = this.store.close_time_sat
      this.open_time_sun = this.store.open_time_sun
      this.close_time_sun = this.store.close_time_sun
      this.slider = this.store.num_persons
      this.duration = this.store.duration
      this.lat = this.store.lat
      this.lng = this.store.lng
      this.address = this.store.address
      this.phone = this.store.phone
      this.minutes_before_out = this.store.minutes_before_out
      this.minutes_before_expire = this.store.minutes_before_expire
      this.timezone = this.store.timezone
      this.autocomplete = null
      this.center = {
        lat: this.store.lat,
        lng: this.store.lng
      }
      this.map_center = this.center
      this.zoom = 18
      this.display_timezone = this.getTimezoneNameByValue

      if (this.google) {
        this.autocomplete = new this.google.maps.places.Autocomplete(this.$refs.text_input.$refs.input, {componentRestrictions: {country: 'US'}});
        this.autocomplete.addListener('place_changed', this.fillInAddress);
        this.geocoder = new this.google.maps.Geocoder();
      }
    },
    beforeDestroy: function () {
      delete this.autocomplete;
      delete this.geocoder;
    },
    watch:
      {
        google() {
          if (google != null) {
            this.autocomplete = new this.google.maps.places.Autocomplete(this.$refs.text_input.$refs.input, {componentRestrictions: {country: 'US'}});
            this.autocomplete.addListener('place_changed', this.fillInAddress);
            this.geocoder = new this.google.maps.Geocoder();
          }
        },
        autocomplete() {
          if (this.address) {
            this.$nextTick(() => {
              this.fillInAddress()
            });
          }
        }
      },
    methods: {

      setTimezone(zone) {
        this.timezone = zone.value
        this.display_timezone = zone.text

      },
      toggleOverlay() {
        this.overlay = !this.overlay
      },
      convert_to_time(time, day) {
        var time_in_minutes = this[time + '_' + day.abbr]
        var ap = [' AM', ' PM']; // AM-PM
        var hh = Math.floor(time_in_minutes / 60); // getting hours of day in 0-24 format
        var mm = (time_in_minutes % 60); // getting minutes of the hour in 0-55 format
        var str = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]

        return str.replace(/00:/, '12:')
      },
      sync() {
        if (this.map_center != this.center) {
          this.map_center = this.center
          var that = this
          if (this.timer_id) {
            clearTimeout(this.timer_id)
          }
          this.address = "Fetching Address..."
          this.timer_id = setTimeout(() => {
            this.geocoder.geocode({'location': this.center}, (results, status) => {
              if ((status == "OK") && (results.length > 0)) {
                that.address = results[0].formatted_address;
              } else {
                that.address = ''
              }
            })
          }, 500)
        }
      },
      updateCenter(latLng) {
        this.center = {
          lat: latLng.lat(),
          lng: latLng.lng(),
        }
        this.address = "Fetching Address..."
      },
      reInt() {
        delete this.autocomplete;
        this.autocomplete = new this.google.maps.places.Autocomplete(this.$refs.text_input.$refs.input, {componentRestrictions: {country: 'US'}});
        this.geocoder = new this.google.maps.Geocoder();
        this.autocomplete.addListener('place_changed', this.fillInAddress);
      },
      fillInAddress() {
        var results = this.autocomplete.getPlace()
        if (results && results.formatted_address) {
          this.address = results.formatted_address;
          this.center = {
            lat: results.geometry.location.lat(),
            lng: results.geometry.location.lng(),
          }
          this.map_center = this.center
          this.lat = this.center.lat;
          this.lng = this.center.lng;
          this.zoom = 18
        }
      },

      saveStore() {
        var that = this;
        that.$router.push({name: PAGE_IDS.STORE_DETAILS, params: {store_id: that.store.id}})
        let updated_store = {

          id: this.store.id,
          brand_id: this.store.brand_id,
          name: this.store_name,
          storemanagers: this.store.storemanagers,
          security: this.store.security,
          phone: this.phone,
          open_time_mon: this.open_time_mon,
          close_time_mon: this.close_time_mon,
          open_time_tue: this.open_time_tue,
          close_time_tue: this.close_time_tue,
          open_time_wed: this.open_time_wed,
          close_time_wed: this.close_time_wed,
          open_time_thu: this.open_time_thu,
          close_time_thu: this.close_time_thu,
          open_time_fri: this.open_time_fri,
          close_time_fri: this.close_time_fri,
          open_time_sat: this.open_time_sat,
          close_time_sat: this.close_time_sat,
          open_time_sun: this.open_time_sun,
          close_time_sun: this.close_time_sun,
          num_persons: this.slider,
          minutes_before_out: this.minutes_before_out,
          minutes_before_expire: this.minutes_before_expire,
          duration: this.duration,
          address: this.address,
          timezone: this.timezone,
          lat: this.lat,
          lng: this.lng,

        }
        that.$store.dispatch('updateStore', updated_store)
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doUpdateStore, updated_store))
          .then((res) => {
            that.$store.dispatch('updateStore', res.data.doUpdateStore)

          })
          .catch((e) => {
                Vue.prototype.$Amplify.API.graphql(Vue.prototype.$Amplify.graphqlOperation(getStore, {id: that.store.id}))
              .then((res) => {
                this.$store.dispatch('updateStore', res.data.getStore)
              })
            process_api_error(`Error Editing Store`, e)
          });
      }
    },
    computed: {
      ...mapGetters(['timezoneValues', 'loadingState', 'getCurrentBrand', 'getCurrentStore', 'getStoreById', 'isBrandManager']),
      store() {
        return this.getStoreById(this.$route.params.store_id)
      },
      getTimezoneNameByValue() {
        let timezone = this.timezoneValues.filter(zone => zone.value === this.timezone)
        return timezone[0].text
      },
      google: gmapApi,
      time_values() {
        var x = 30; //minutes interval
        var times = []; // time array
        var tt = 0; // start time
        var ap = [' AM', ' PM']; // AM-PM

        //loop to increment the time and push results in array
        for (var i = 0; tt < 24 * 60; i++) {
          var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
          var mm = (tt % 60); // getting minutes of the hour in 0-55 format
          var str = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
          var val = tt
          if (str.includes('00:')) {
            times.push({'value': val, 'text': str.replace(/00:/, '12:')})
          } else {
            times.push({'value': val, 'text': str})
          }
          tt = tt + x;
        }
        return times
      },

    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/Stores/StoreEdit.vue